import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Package} from '../package.interface';
import {AuthService} from '@services/auth.service';
import {UserNamespace} from '@namespaces/user.namespace';

@Component({
    selector: 'name',
    templateUrl: './packages-list.component.html',
})

export class PackagesListComponent implements OnInit {

    public package: Package;

    public canViewDocuments = false;

    constructor(
        private route: ActivatedRoute,
        private authService: AuthService,
    ) {
    }

    ngOnInit() {
        this.package = this.route.snapshot.data.packageValue;

        this.canViewDocuments = this.authService.hasPermissions([UserNamespace.Permission.structureUnitDocumentList]);
    }
}
